import { Component, ElementRef, OnDestroy, OnInit, signal, ViewChild } from '@angular/core'
import { PdfGeneratorService } from '../../services/pdf-generator.service'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ProposalPdf, PrpoposalOfferConditions } from './proposal-pdf.model'
import { Subscription } from 'rxjs'
import { ProposalPdfService } from '../../services/proposal-pdf.service'
import { StoneOffer } from '../../../features/custom-offers/types/offers-types'
import { PromoStoneRepricingFees } from '../../proposal-mdr-table/proposal-mdr-table.component'

@Component({
    selector: 'app-proposal-pdf',
    templateUrl: './proposal-pdf.component.html',
    styleUrls: ['./proposal-pdf.component.scss'],
})
export class ProposalPdfComponent implements OnInit, OnDestroy {
    @ViewChild('pdf_element')
    public pdf_element!: ElementRef<HTMLElement>

    public subscription!: Subscription

    public proposal!: ProposalPdf
    public date = new Date()

    public offer_type = 'aluguel'

    promoStoneFees: { hitGoal: PromoStoneRepricingFees; didntReachGoal: PromoStoneRepricingFees } = {
        hitGoal: {
            debit: 0,
            credit: 0,
            psj1: 0,
            psj2: 0,
            rav: 0,
        },
        didntReachGoal: {
            debit: 0,
            credit: 0,
            psj1: 0,
            psj2: 0,
            rav: 0,
        },
    }

    constructor(
        public readonly ngbActiveModal: NgbActiveModal,
        private readonly pdfGeneratorService: PdfGeneratorService,
        private readonly proposalPdfService: ProposalPdfService,
    ) {}

    ngOnInit(): void {
        this.subscription = this.proposalPdfService.proposalPdfSubject.subscribe((proposal: ProposalPdf | null) => {
            if (proposal) {
                this.proposal = {
                    ...proposal,
                }
                if (proposal.plan_name) this.changeProposal()

                this.calcFeesByTpv(proposal.tpv, proposal?.offer_conditions)
            }
        })
    }

    changeProposal(): void {
        this.offer_type = 'adesao'
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe()
    }

    public async exportAsPDF() {
        const htmlElement = this.pdf_element.nativeElement
        const fileName = this.proposal.trade_name
        await this.pdfGeneratorService.generate(htmlElement, fileName)
    }

    calcFeesByTpv(tpv: number, conditions: Partial<PrpoposalOfferConditions> | null | undefined) {
        if (!conditions) return

        const agravo = 0.5
        if (conditions.promo_stone_group === 6) {
            if (tpv <= 50000) {
                this.promoStoneFees.didntReachGoal = {
                    debit: 1.27 + agravo,
                    credit: 2.32 + agravo,
                    psj1: 2.88 + agravo,
                    psj2: 3.11 + agravo,
                    rav: 1.95 + agravo,
                }

                this.promoStoneFees.hitGoal = {
                    debit: 0.99 + agravo,
                    credit: 1.97 + agravo,
                    psj1: 2.73 + agravo,
                    psj2: 2.96 + agravo,
                    rav: 1.8 + agravo,
                }

                return
            }

            if (tpv > 50000 && tpv <= 100000) {
                this.promoStoneFees.didntReachGoal = {
                    debit: 1.17 + agravo,
                    credit: 2.22 + agravo,
                    psj1: 2.77 + agravo,
                    psj2: 3.0 + agravo,
                    rav: 1.83 + agravo,
                }

                this.promoStoneFees.hitGoal = {
                    debit: 0.89 + agravo,
                    credit: 2.0 + agravo,
                    psj1: 2.67 + agravo,
                    psj2: 2.94 + agravo,
                    rav: 1.67 + agravo,
                }

                return
            }

            if (tpv > 100000) {
                this.promoStoneFees.didntReachGoal = {
                    debit: 1.04 + agravo,
                    credit: 2.16 + agravo,
                    psj1: 2.96 + agravo,
                    psj2: 3.39 + agravo,
                    rav: 1.75 + agravo,
                }

                this.promoStoneFees.hitGoal = {
                    debit: 0.89 + agravo,
                    credit: 1.99 + agravo,
                    psj1: 2.42 + agravo,
                    psj2: 2.71 + agravo,
                    rav: 1.62 + agravo,
                }

                return
            }
        }

        if (conditions.promo_stone_group === 5) {
            if (tpv <= 50000) {
                this.promoStoneFees.didntReachGoal = {
                    debit: 1.27 + agravo,
                    credit: 2.37 + agravo,
                    psj1: 2.93 + agravo,
                    psj2: 3.16 + agravo,
                    rav: 2.0 + agravo,
                }

                this.promoStoneFees.hitGoal = {
                    debit: 0.99 + agravo,
                    credit: 2.07 + agravo,
                    psj1: 2.96 + agravo,
                    psj2: 3.36 + agravo,
                    rav: 1.8 + agravo,
                }

                return
            }

            if (tpv > 50000 && tpv <= 100000) {
                this.promoStoneFees.didntReachGoal = {
                    debit: 1.17 + agravo,
                    credit: 2.27 + agravo,
                    psj1: 2.82 + agravo,
                    psj2: 3.05 + agravo,
                    rav: 1.88 + agravo,
                }

                this.promoStoneFees.hitGoal = {
                    debit: 0.89 + agravo,
                    credit: 2.1 + agravo,
                    psj1: 2.9 + agravo,
                    psj2: 3.34 + agravo,
                    rav: 1.67 + agravo,
                }

                return
            }

            if (tpv > 100000) {
                this.promoStoneFees.didntReachGoal = {
                    debit: 1.04 + agravo,
                    credit: 2.19 + agravo,
                    psj1: 2.93 + agravo,
                    psj2: 3.3 + agravo,
                    rav: 1.82 + agravo,
                }

                this.promoStoneFees.hitGoal = {
                    debit: 0.89 + agravo,
                    credit: 2.09 + agravo,
                    psj1: 2.65 + agravo,
                    psj2: 3.11 + agravo,
                    rav: 1.62 + agravo,
                }

                return
            }
        }
    }
}
